import {
  GET_FILTERS_START,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_ERROR,
  SET_CUSTOM_FILTERS,
  RESET_CUSTOM_FILTERS,
} from '../constants';

const initialState = {
  name: '',
  order: '',
  filters: [],
  filtersLoaded: false,
  filtersLoading: false,
};

export default function getFilters(state = initialState, action) {
  switch (action.type) {
    case GET_FILTERS_START: {
      return {
        ...state,
        filtersLoading: true,
      };
    }
    case GET_FILTERS_SUCCESS: {
      return {
        ...state,
        filtersLoaded: true,
        filtersLoading: false,
        filters: action.payload.filters,
        test: action.payload.test,
      };
    }
    case GET_FILTERS_ERROR: {
      return {
        filtersLoading: false,
        ...state,
      };
    }
    default:
      return state;
  }
}

const customFiltersInitialData = {};

export const customFilters = (state = customFiltersInitialData, action) => {
  switch (action.type) {
    case SET_CUSTOM_FILTERS: {
      return {
        optionsDict: action.payload.optionsDict || {},
        filterMapping: action.payload.filterMapping || [],
      };
    }
    case RESET_CUSTOM_FILTERS: {
      return customFiltersInitialData;
    }
    default:
      return state;
  }
};
